import { Stack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { BuyerParticipationRequestDetailDto } from "../../../../../autogen/bff-api";
import { DocumentsAsOwnerTable } from "../../../../../common/documents/DocumentsAsOwnerTable";

interface Props {
  detail: BuyerParticipationRequestDetailDto;
}

// Every evidence document across the criterion responses, deduplicated.
export const RequestDocumentsTab = ({ detail }: Props) => {
  const { t } = useTranslation();
  const documents = Array.from(
    new Map(
      (detail.request.qualificationResponses ?? [])
        .flatMap((response) => response.evidenceDocuments ?? [])
        .map((document) => [document.id, document] as const),
    ).values(),
  );

  return (
    <Stack spacing="4">
      <DocumentsAsOwnerTable
        documents={documents}
        emptyDescription={String(t("The supplier has not attached documents to this request."))}
      />
    </Stack>
  );
};
